module.exports = __webpack_public_path__ + "img/icon-filter.5bc07a92.svg";